import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined';
import { useUserRoleData } from '../account/Account';
import './dashboard2.scss';
import Auth from '../../utils/auth';
import { useUserData } from '../account/Account';
import { ClassObjectDTO } from '../../components/dto/classObject.dto';
import { UserObjectDTO } from '../../api/dto/userObject.dto';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { VxAPI } from '../../api/vx.api';
import SidebarChart, { SideBarChartPropsForScreenSize } from '../../components/charts/bar/SideBar';
import { CourseObjectDTO } from '../../components/dto/courseObject.dto';
import { ModuleObjectDTO } from '../../components/dto/moduleObject.dto';
import { LessonObjectDTO } from '../../components/dto/lessonObject.dto';
import { averageArrays, averageQuizGlobalConfidece, returnFormattedDate } from '../../utils/helpers';
import Certificate, { CertificateProps } from '../../components/certificate/CertificatePDF';
import StudentDashboard, { StudentDashProps } from '../../components/dashboard/StudentDash';
import { DecodedTokenDTO } from '../../utils/dto/decodedToken.dto';
import DomainOutlinedIcon from '@material-ui/icons/DomainOutlined';

const Dashboard = () => {
  const loggedIn = Auth.loggedIn();
  const loggedInUser = Auth.getProfile('id_token') as DecodedTokenDTO;
  if (!loggedIn) {
    window.location.assign('/');
  }
  let lessonIndex = 0;
  let moduleIndex = 0;
  let completedLessonCounts: number[] = [];
  const [loading, setLoading] = useState(true);
  const [searchTextClasses, setSearchTextClasses] = useState<string>('');
  const [searchTextStudents, setSearchTextStudents] = useState<string>('');
  const [searchTextCourses, setSearchTextCourses] = useState<string>('');
  const [searchTextModules, setSearchTextModules] = useState<string>('');
  const [searchTextLessons, setSearchTextLessons] = useState<string>('');
  const [collapse, setCollapse] = useState<string>('');
  const [studentsCollapse, setStudentsCollapse] = useState<boolean[]>([]);
  const [coursesCollapse, setCoursesCollapse] = useState<boolean[]>([]);
  const [modulesCollapse, setModulesCollapse] = useState<boolean[]>([]);
  const [lessonsCollapse, setLessonsCollapse] = useState<boolean[]>([]);
  const [studentDashData, setStudentDashData] = useState<StudentDashProps | null>(null);
  const [sideBarProps, setSideBarProps] = useState<SideBarChartPropsForScreenSize>({
    borderWidth: 1,
    displayLegend: false,
    minBarLength:
      window.innerWidth < 576
        ? 1
        : window.innerWidth < 768
        ? 2
        : window.innerWidth < 992
        ? 3
        : window.innerWidth < 1200
        ? 4
        : 5,
    dataMax: 100, // needs to be set dynamically per chart
    dataMin: 0,
    titleFontSize:
      window.innerWidth < 576
        ? 10
        : window.innerWidth < 768
        ? 10
        : window.innerWidth < 992
        ? 12
        : window.innerWidth < 1200
        ? 14
        : 16,
    yAxisLabelFontSize:
      window.innerWidth < 576
        ? 10
        : window.innerWidth < 768
        ? 10
        : window.innerWidth < 992
        ? 12
        : window.innerWidth < 1200
        ? 14
        : 16,
    height: 100,
    width: 100,
    padding: 10,
  });

  const [courseObjectArrayData, setCourseObjectArrayData] = useState<CourseObjectDTO[]>([
    {
      customerId: 0,
      useCaseId: 0,
      courseId: 0,
      title: '',
      creator: 0,
      description: '',
      notes: '',
      tags: [0],
      classes: [0],
      courseModules: [],
      lessonCount: 0,
      studentCount: 0,
      completedCount: 0
    },
  ]);

  const [updatedCourseObjectArrayData, setUpdatedCourseObjectArrayData] = useState<CourseObjectDTO[]>([]);
  const [students, setStudents] = useState<UserObjectDTO[]>();
  const { userData } = useUserData();
  const { userRoleData } = useUserRoleData();
  const courseRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});
  const moduleRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});
  const lessonRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});
  const [nonNullModuleRefs, setNonNullModuleRefs] = useState<HTMLDivElement[]>([]);
  const [nonNullLessonRefs, setNonNullLessonRefs] = useState<HTMLDivElement[]>([]);
  const chartHeight = 6;
  const [displayCert, setDisplayCert] = useState<boolean>(false);
  const [certificateData, setCertificateData] = useState<CertificateProps | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      const classData = await VxAPI.getAllClassesHierarchyData();
      console.log("Course Data:");
      console.log(classData[0].courseList);
      if (classData) {
        setCourseObjectArrayData(classData[0].courseList);
        setUpdatedCourseObjectArrayData(classData[0].courseList);
        setLoading(false);
      }
      const studentRole = 1;
      const studentData = await VxAPI.getUserByRoleByCustomerId(studentRole);
      if (studentData) {
        console.log("Student Data:");
        console.log(studentData);
        setStudents(studentData);
      }
    };

    fetchData().catch(console.error);
  }, []);

  useEffect(() => {
    if (loggedInUser && userData) {
      if (userData.userId !== loggedInUser.userId) {
        Auth.logout();
      }
    }
  }, [loggedInUser, userData]);

  const [hiddenModuleIndices, setHiddenModuleIndices] = useState<number[]>([]);
  const handleModuleArrow = (index: number) => {
    console.log("module" + index);
    setHiddenModuleIndices(prev => prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]);
  };

  const [hiddenLessonIndices, setHiddenLessonIndices] = useState<number[]>([]);
  const handleStudentsArrow = (index: number) => {
    console.log("students" + index);
    setHiddenLessonIndices(prev => prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]);
  };

  const getNonNullRefs = (refs: { [key: string]: HTMLDivElement | null }) => {
    return Object.values(refs).filter((ref) => ref !== null);
  };

  useEffect(() => {
    if (!courseRefs.current) return;
    const nonNullModuleRefs = getNonNullRefs(moduleRefs.current);
    const nonNullLessonRefs = getNonNullRefs(lessonRefs.current);
    if (nonNullModuleRefs.length <= 0) return;
    const courseId = nonNullModuleRefs[0]?.id.split('-')[0];
    setNonNullModuleRefs(nonNullModuleRefs as HTMLDivElement[]);
    setNonNullLessonRefs(nonNullLessonRefs as HTMLDivElement[]);
    // console.log('course: ', courseRefs.current[courseId as string]);
    // console.log('modules: ', nonNullModuleRefs);
    // console.log('lessons: ', nonNullLessonRefs);
  }, [lessonsCollapse, modulesCollapse, collapse]);

  const handleCertficateData = (date: string, name: string, course: string, signatureName: string) => {
    if (certificateData === null) {
      setCertificateData({ date, name, course, signatureName });
      setDisplayCert(true);
    } else {
      setCertificateData(null);
      setDisplayCert(false);
    }
  };

  useEffect(() => {
    if (
      searchTextClasses.trim() === '' &&
      searchTextCourses.trim() === '' &&
      searchTextStudents.trim() === '' &&
      searchTextModules.trim() === '' &&
      searchTextLessons.trim() === ''
    ) {
      setUpdatedCourseObjectArrayData(courseObjectArrayData);
      return;
    }

    let updatedCourseData = courseObjectArrayData;

    // console.log('updatedClassData BEFORE: ', updatedClassData);

    setUpdatedCourseObjectArrayData(updatedCourseData);
  }, [searchTextClasses, searchTextCourses, searchTextLessons, searchTextModules, searchTextStudents]);

  return (
    <>
      {loading ? (
        <>
          <div>
            <h1 className="loading">Loading...</h1>
          </div>
        </>
      ) : userRoleData?.title === 'Student' && studentDashData?.studentData !== null ? (
        <>
          <StudentDashboard
            studentData={studentDashData?.studentData}
            studentClassData={studentDashData?.studentClassData as ClassObjectDTO[]}
          />
        </>
      ) : displayCert && certificateData ? (
        <>
          <Certificate
            name={certificateData.name}
            course={certificateData.course}
            date={certificateData.date}
            signatureName={certificateData.signatureName}
            callback={() => handleCertficateData('', '', '', '')}
          />
        </>
      ) : (
        <>
          <div className="dashboard2">
            <div className="nav">
              <ul>
                <Link to="/olddashboard">
                  <span>
                    <DashboardOutlinedIcon fontSize="large" />
                    <br />
                  </span>
                  Old Dasboard
                </Link>
              </ul>
            </div>
            <div className="dash-header">
              <h1>Course Completion</h1>
            </div>

            {updatedCourseObjectArrayData && updatedCourseObjectArrayData.length > 0 ? (
              <>
                {updatedCourseObjectArrayData.map((qiCourse: CourseObjectDTO, index: number) => {
                  return (
                    <>
                      <div className="unit-header">
                        <h1 className="unit-title">{qiCourse.title}</h1>
                        <>
                          <div className="unit-dd">
                            <div className="unit-details">
                              <h1 className="unit-title section">Modules<br />&nbsp;</h1>
                              <>
                                {qiCourse.courseModules?.map((courseModule: ModuleObjectDTO) => {
                                  const localModuleIndex = ++moduleIndex;
                                  // calculate counts here?
                                  const completedCourseCount = courseModule.lessons?.reduce((lessonAcc, lesson) => {
                                    const completedPerLesson = students?.reduce((studentAcc, student) => {
                                      const lessonMetric = student.studentMetrics?.lessons.find(
                                        metric => metric.lessonId === lesson.lessonId
                                      );
                                      return lessonMetric?.dateCompleted ? studentAcc + 1 : studentAcc;
                                    }, 0);

                                    return lessonAcc + (completedPerLesson ?? 0);
                                  }, 0);

                                  let studentsLength = students?.length ?? 0;
                                  let lessonCount = courseModule.lessons?.length ?? 0;
                                  let studentLessons = studentsLength * lessonCount;
                                  let percentageComplete = (((completedCourseCount ?? 0) / studentLessons) * 100).toFixed(1);

                                  let progressClassName = "unit-title inprogress";
                                  if(completedCourseCount === 0 )
                                    progressClassName = "unit-title incomplete";
                                  else if(completedCourseCount == studentLessons)
                                    progressClassName = "unit-title complete";

                                  return (
                                    <>
                                      <div className={(hiddenModuleIndices.includes(localModuleIndex) ? 'unit-header active' : 'unit-header') + ' flex'}>
                                        <span className="lesson-headers"><h1 className="unit-title">{courseModule.title}</h1></span><span className="lesson-headers"><h1 className={progressClassName}><big>{percentageComplete}%</big> Module Completion</h1></span><br />&nbsp;
                                        <FontAwesomeIcon id={`courses-dd-icon`} icon={!hiddenModuleIndices.includes(localModuleIndex) ? faAngleUp : faAngleDown} onClick={() => handleModuleArrow(localModuleIndex)} />
                                      </div>
                                      {hiddenModuleIndices.includes(localModuleIndex) && (
                                        <div className="unit-header" id={'students' + moduleIndex}>
                                          <div className="unit-dd">
                                            <div className="unit-details">
                                              <h1 className="unit-title section">Lessons<br />&nbsp;</h1>
                                              <>
                                                {courseModule.lessons?.map((lesson: LessonObjectDTO, index: number) => {
                                                  const localLessonIndex = ++lessonIndex;

                                                  const completedCount = students?.reduce((count, student) => {
                                                    const lessonMetric = student.studentMetrics?.lessons.find(
                                                      metric => metric.lessonId === lesson.lessonId
                                                    );

                                                    if (lessonMetric?.dateCompleted) {
                                                      return count + 1;
                                                    }

                                                    return count;
                                                  }, 0);

                                                  let progressClassName = "unit-title inprogress";
                                                  if(completedCount == 0 )
                                                    progressClassName = "unit-title incomplete";
                                                  else if(completedCount == students?.length)
                                                    progressClassName = "unit-title complete";

                                                  return (
                                                    <>
                                                      <div className={(hiddenLessonIndices.includes(localLessonIndex) ? 'unit-header active' : 'unit-header') + ' flex'}>
                                                        <span className="lesson-headers"><h1 className="unit-title">{lesson.title}</h1></span><span className="lesson-headers"><h1 className={progressClassName}><big>{completedCount}/{students?.length}</big> students completed</h1></span><br />&nbsp;
                                                        <FontAwesomeIcon id={`courses-dd-icon`} icon={!hiddenLessonIndices.includes(localLessonIndex) ? faAngleUp : faAngleDown} onClick={() => handleStudentsArrow(localLessonIndex)} />
                                                      </div>
                                                      {hiddenLessonIndices.includes(localLessonIndex) && (
                                                        <div className="unit-header" id={'students' + lessonIndex}>
                                                          <div className="unit-dd">
                                                            <div className="unit-details">
                                                              <span className="lesson-headers"><h1 className="unit-title">Students</h1></span><span className="lesson-headers"><h1 className="unit-title">Date/Time Completed</h1></span><br />&nbsp;
                                                              <>
                                                                {students?.map(student => {
                                                                  const lessonMetric = student.studentMetrics?.lessons.find(metric => metric.lessonId === lesson.lessonId);

                                                                  return (
                                                                    <>
                                                                      <div className="unit-header flex">
                                                                        <span className="lesson-detail"><h1 className="unit-title">{student.firstName} {student.lastName}</h1></span><span className="lesson-detail"><h1 className={!!lessonMetric?.dateCompleted ? "unit-title complete" : "unit-title incomplete"}>{!!lessonMetric?.dateCompleted ? lessonMetric?.dateCompleted.toLocaleString() : "Incomplete"}</h1></span>
                                                                      </div>
                                                                    </>
                                                                  )})
                                                                }
                                                              </>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      )}
                                                    </>
                                                  )})
                                                }
                                              </>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </>
                                  )
                                  // const classStudents: (UserObjectDTO | undefined)[] | undefined =
                                  //   qiCourse.students?.map((studentId: number) => {
                                  //     return students?.find(
                                  //       (student: UserObjectDTO) => student.userId === studentId,
                                  //     );
                                  //   });
                                  // let lessonCompletedDates: string[] = [];
                                  // const studentCompletedLessonIds = classStudents?.map((student) =>
                                  //   student?.studentMetrics?.lessons?.map((lesson) => {
                                  //     if (lesson.dateCompleted) {
                                  //       lessonCompletedDates.push(lesson.dateCompleted as unknown as string);
                                  //       return lesson.lessonId;
                                  //     }
                                  //   }),
                                  // );
                                  // // console.log('student completed lessonid: ', studentCompletedLessonIds);
                                  // const latestCompletedDate = lessonCompletedDates.reduce((latest, current) => {
                                  //   return current > latest ? current : latest;
                                  // }, lessonCompletedDates[0]);
                                  // const studentNames = classStudents?.map((student) => {
                                  //   return `${student?.firstName} ${student?.lastName}`;
                                  // });

                                  // const fullCourseData = courseObjectArrayData
                                  //   .find((classData) => classData.classId === qiCourse.classId)
                                  //   ?.courseList?.find((c) => c.courseId === course.courseId);
                                  // count the number of lessons for the course
                                  // const courseLessonsIds =
                                  //   fullCourseData?.courseModules?.flatMap((module: ModuleObjectDTO) => {
                                  //     return Array.isArray(module.lessons)
                                  //       ? module.lessons.map((lesson: LessonObjectDTO) => lesson.lessonId)
                                  //       : [];
                                  //   }) || [];
                                  // count if lesson id exists on student metrics and has completed date
                                  // get progress value and multiply by 100
                                  // const progressArray = courseLessonsIds?.map((id) => {
                                  //   return studentCompletedLessonIds?.map((lId) => {
                                  //     let count = 0;
                                  //     if (lId?.includes(id)) count = 1;
                                  //     return lId?.length ? count : 0;
                                  //   });
                                  // });
                                  //
                                  // const studentsDataValues = averageArrays(progressArray as number[][], true);

                                  // Determine bar colors based on data values
                                  // const backgroundColors = studentsDataValues?.map((value) => {
                                  //   if (value === 0) return 'rgba(255, 0, 0, 0.6)'; // Red for Not Started
                                  //   if (value > 0 && value < 100) return 'rgba(255, 206, 86, 0.6)'; // Yellow for Started
                                  //   return 'rgba(0, 255, 0, 0.6)'; // Green for Completed
                                  // });
                                  //
                                  // const modules = course.courseModules;
                                  //
                                  // let chartDivHeight =
                                  //   (studentNames?.length as number) > 1
                                  //     ? chartHeight * (studentNames?.length as number)
                                  //     : 12;
                                  // const nonNullModuleKeys =
                                  //   Object.keys(moduleRefs.current).filter(
                                  //     (key) => moduleRefs.current[key] !== null,
                                  //   )[0] || null;
                                  // console.log('moduleRefs: ', moduleRefs.current);
                                  // const modulesOpen = modulesCollapse.some((value) => value === true);
                                  // console.log('modules open: ', modulesOpen);
                                  // console.log(nonNullModuleKeys);
                                  // const currentCourseId = nonNullModuleKeys
                                  //   ? nonNullModuleKeys.split('-')[0]
                                  //   : null;
                                  // console.log('current course id: ', currentCourseId);
                                  // const hideElement =
                                  //   currentCourseId && currentCourseId !== `${course.courseId}` && modulesOpen;
                                  // console.log('hide element: ', hideElement);
                                  // const expandedElement =
                                  //   currentCourseId && currentCourseId === `${course.courseId}` && modulesOpen;
                                  // console.log('expanded el: ', expandedElement);
                                  /*
                                  return (
                                    <div
                                      style={{
                                        display: hideElement ? 'none' : 'block',
                                      }}
                                      className={expandedElement ? 'student-info expanded' : 'student-info'}
                                      id={`${course.courseId}`}
                                      ref={(el) => setCourseRef(`${course.courseId}`, el)}
                                    >
                                      <h1 className={modulesCollapse[index] ? 'active-font' : undefined}>
                                        {course.title}
                                      </h1>
                                      <div className="datachart">
                                        <div
                                          className="course-progress-chart"
                                          style={{
                                            height: `${chartDivHeight}rem`,
                                          }}
                                        >
                                          <SidebarChart
                                            dataValues={studentsDataValues}
                                            yLabels={studentNames as string[]}
                                            barColors={backgroundColors}
                                            barBorderColors={backgroundColors}
                                            borderWidth={sideBarProps.borderWidth}
                                            displayLegend={sideBarProps.displayLegend}
                                            title="Course Progress"
                                            className="course-progress-chart"
                                            minBarLength={sideBarProps.minBarLength}
                                            dataMax={sideBarProps.dataMax}
                                            dataMin={sideBarProps.dataMin}
                                            titleFontSize={sideBarProps.titleFontSize}
                                            yAxisLabelFontSize={sideBarProps.yAxisLabelFontSize}
                                            height={
                                              (studentNames?.length as number) > 1
                                                ? chartHeight * (studentNames?.length as number)
                                                : 12
                                            }
                                            width={sideBarProps.width}
                                            padding={sideBarProps.padding}
                                          />
                                          <div
                                            className="cert-btn-divs"
                                            style={{
                                              marginTop: `${
                                                chartDivHeight /
                                                (studentsDataValues?.length ? studentsDataValues.length + 1 : 1)
                                              }rem`,
                                            }}
                                          >
                                            {studentsDataValues.map((score, index) => {
                                              const currentStudent =
                                                studentNames && studentNames?.length > 0
                                                  ? studentNames[index]
                                                  : '';
                                              if (score === 100) {
                                                return (
                                                  <div
                                                    className="cert-btn"
                                                    style={{
                                                      height: `${
                                                        chartDivHeight /
                                                        (studentsDataValues?.length
                                                          ? studentsDataValues.length + 1
                                                          : 1)
                                                      }rem`,
                                                      alignContent:
                                                        studentsDataValues.length && studentsDataValues.length > 2
                                                          ? 'center'
                                                          : undefined,
                                                    }}
                                                  >
                                                    <button
                                                      onClick={() =>
                                                        handleCertficateData(
                                                          returnFormattedDate(latestCompletedDate),
                                                          currentStudent,
                                                          course.title as string,
                                                          'Authorizing Official',
                                                        )
                                                      }
                                                    >
                                                      Cert
                                                    </button>
                                                  </div>
                                                );
                                              } else {
                                                return (
                                                  <div
                                                    className="no-cert-btn"
                                                    style={{
                                                      height: `${
                                                        chartDivHeight /
                                                        (studentsDataValues?.length
                                                          ? studentsDataValues.length + 1
                                                          : 1)
                                                      }rem`,
                                                    }}
                                                  ></div>
                                                );
                                              }
                                            })}
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className={
                                          modulesCollapse[index] ? 'unit-header-dd active' : 'unit-header-dd'
                                        }
                                      >
                                        <h1>Modules</h1>
                                        <FontAwesomeIcon
                                          id={`modules-dd-icon-${course.courseId}`}
                                          icon={modulesCollapse[index] ? faAngleUp : faAngleDown}
                                          onClick={() => handleModulesArrow(index)}
                                        />
                                      </div>
                                      <>
                                        {modulesCollapse[index] ? (
                                          <>
                                            {modules?.map((module: ModuleObjectDTO, index: number) => {
                                              // console.log('module lessons: ', module.lessons? module.lessons : 'no lessons')
                                              const fullModuleData = courseObjectArrayData
                                                .find((courseData) => courseData.courseId === qiCourse.courseId)
                                                ?.courseModules?.find((c) => c.courseId === course.courseId);
                                              const fullLessonData = Array.isArray(fullModuleData?.lessons)
                                                ? fullModuleData?.lessons
                                                : [];
                                              const lessons = Array.isArray(module.lessons) ? module.lessons : [];
                                              const moduleProgressArray = fullLessonData?.map((lesson) => {
                                                return studentCompletedLessonIds?.map((lId) => {
                                                  let count = 0;
                                                  // console.log('lId: ', lId);
                                                  if (lId?.includes(lesson.lessonId)) count = 1;
                                                  return lId?.length ? count : 0;
                                                });
                                              });
                                              const moduleDataValues = averageArrays(
                                                moduleProgressArray as number[][],
                                                true,
                                              );

                                              // Determine bar colors based on data values
                                              const moduleBackgroundColors = moduleDataValues?.map((value) => {
                                                if (value === 0) return 'rgba(255, 0, 0, 0.6)'; // Red for Not Started
                                                if (value > 0 && value < 100) return 'rgba(255, 206, 86, 0.6)'; // Yellow for Started
                                                return 'rgba(0, 255, 0, 0.6)'; // Green for Completed
                                              });

                                              const nonNullLessonKeys =
                                                Object.keys(lessonRefs.current).filter(
                                                  (key) => lessonRefs.current[key] !== null,
                                                )[0] || null;
                                              // console.log('lessonRefs: ', lessonRefs.current);
                                              const lessonsOpen = lessonsCollapse.some((value) => value === true);
                                              // console.log('lessons open: ', lessonsOpen);
                                              // console.log(nonNullLessonKeys);
                                              const currentModuleId = nonNullLessonKeys
                                                ? nonNullLessonKeys.split('-')[1]
                                                : null;
                                              // console.log('current Module id: ', currentModuleId);

                                              return (
                                                <div
                                                  style={{
                                                    display:
                                                      currentModuleId &&
                                                      currentModuleId !== `${module.moduleId}` &&
                                                      lessonsOpen
                                                        ? 'none'
                                                        : 'block',
                                                  }}
                                                  className="module-info"
                                                  id={`${course.courseId}-${module.moduleId}`}
                                                  ref={(el) =>
                                                    setModuleRef(`${course.courseId}-${module.moduleId}`, el)
                                                  }
                                                >
                                                  <h1
                                                    className={lessonsCollapse[index] ? 'active-font' : undefined}
                                                  >
                                                    {module.title}
                                                  </h1>
                                                  <div className="datachart">
                                                    <div
                                                      className="course-progress-chart"
                                                      style={{
                                                        height: `${chartDivHeight}rem`,
                                                      }}
                                                    >
                                                      <SidebarChart
                                                        dataValues={moduleDataValues}
                                                        yLabels={studentNames as string[]}
                                                        barColors={moduleBackgroundColors}
                                                        barBorderColors={moduleBackgroundColors}
                                                        borderWidth={sideBarProps.borderWidth}
                                                        displayLegend={sideBarProps.displayLegend}
                                                        title="Module Progress"
                                                        className="course-progress-chart"
                                                        minBarLength={sideBarProps.minBarLength}
                                                        dataMax={sideBarProps.dataMax}
                                                        dataMin={sideBarProps.dataMin}
                                                        titleFontSize={sideBarProps.titleFontSize}
                                                        yAxisLabelFontSize={sideBarProps.yAxisLabelFontSize}
                                                        height={
                                                          (studentNames?.length as number) > 1
                                                            ? chartHeight * (studentNames?.length as number)
                                                            : 12
                                                        }
                                                        width={sideBarProps.width}
                                                        padding={sideBarProps.padding}
                                                      />
                                                    </div>
                                                  </div>
                                                  <div
                                                    className={
                                                      lessonsCollapse[index]
                                                        ? 'unit-header-dd active'
                                                        : 'unit-header-dd'
                                                    }
                                                  >
                                                    <h1>Lessons</h1>
                                                    <FontAwesomeIcon
                                                      id={`lessons-dd-icon-${module.moduleId}`}
                                                      icon={lessonsCollapse[index] ? faAngleUp : faAngleDown}
                                                      onClick={() => handleLessonsArrow(index)}
                                                    />
                                                  </div>
                                                  <>
                                                    {lessonsCollapse[index] ? (
                                                      <>
                                                        {lessons?.map(
                                                          (lesson: LessonObjectDTO, index: number) => {
                                                            const lessonProgressArray: number[] = [];
                                                            studentCompletedLessonIds?.map((lId) => {
                                                              if (lId?.includes(lesson.lessonId)) {
                                                                lessonProgressArray.push(100);
                                                              } else {
                                                                lessonProgressArray.push(0);
                                                              }
                                                            });

                                                            // Determine bar colors based on data values
                                                            const lessonBackgroundColors =
                                                              lessonProgressArray?.map((value) => {
                                                                if (value === 0) return 'rgba(255, 0, 0, 0.6)'; // Red for Not Started
                                                                if (value > 0 && value < 100)
                                                                  return 'rgba(255, 206, 86, 0.6)'; // Yellow for Started
                                                                return 'rgba(0, 255, 0, 0.6)'; // Green for Completed
                                                              });
                                                            return (
                                                              <div
                                                                className="lesson-info"
                                                                id={`${course.courseId}-${module.moduleId}-${lesson.lessonId}`}
                                                                ref={(el) =>
                                                                  setLessonRef(
                                                                    `${course.courseId}-${module.moduleId}-${lesson.lessonId}`,
                                                                    el,
                                                                  )
                                                                }
                                                              >
                                                                <h1>{lesson.title}</h1>
                                                                <div className="datachart">
                                                                  <div
                                                                    className="course-progress-chart"
                                                                    style={{
                                                                      height: `${chartDivHeight}rem`,
                                                                    }}
                                                                  >
                                                                    <SidebarChart
                                                                      dataValues={lessonProgressArray}
                                                                      yLabels={studentNames as string[]}
                                                                      barColors={lessonBackgroundColors}
                                                                      barBorderColors={lessonBackgroundColors}
                                                                      borderWidth={sideBarProps.borderWidth}
                                                                      displayLegend={sideBarProps.displayLegend}
                                                                      title="Lesson Progress"
                                                                      className="course-progress-chart"
                                                                      minBarLength={sideBarProps.minBarLength}
                                                                      dataMax={sideBarProps.dataMax}
                                                                      dataMin={sideBarProps.dataMin}
                                                                      titleFontSize={sideBarProps.titleFontSize}
                                                                      yAxisLabelFontSize={
                                                                        sideBarProps.yAxisLabelFontSize
                                                                      }
                                                                      height={
                                                                        (studentNames?.length as number) > 1
                                                                          ? chartHeight *
                                                                            (studentNames?.length as number)
                                                                          : 12
                                                                      }
                                                                      width={sideBarProps.width}
                                                                      padding={sideBarProps.padding}
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            );
                                                          },
                                                        )}
                                                      </>
                                                    ) : null}
                                                  </>
                                                </div>
                                              );
                                            })}
                                          </>
                                        ) : null}
                                      </>
                                    </div>
                                  );*/
                                })}
                              </>
                            </div>
                          </div>
                        </>
                      </div>
                    </>
                  );
                })}
              </>
            ) : searchTextClasses !== '' ||
              searchTextCourses !== '' ||
              searchTextLessons !== '' ||
              searchTextModules !== '' ||
              searchTextStudents !== '' ? (
              <div className="no-class">There are no classes associated with the filtered criteria.</div>
            ) : (
              <div className="no-class"> Get started by creating courses for your account!</div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default Dashboard;
